<template>
  <Control v-if="isEnableCategoryAtc" ref="parent" :title="title" :isEdit="isEdit && enabled" :validator="validator" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled" :editor="editor" :enabled="enabled"  :tooltip="tooltip"  :key="title" :required="required" :keyfield="keyfield">
    <template slot="read"><span :class="{cx_autolink : isLink}" @click="onLinkClick">{{ displayName }}</span></template>
    <template slot="edit">
      <!-- setWidthで幅・縦位置を指定しています -->
      <div class="popperList" ref="rect" v-if="showPopper" @wheel="onWheel" :tabindex="0">
        <!-- クエリモードで結果が複数ページ存在する場合にページ移動ボタンを表示する -->
        <!-- ヘッダを上部に表示する場合(変更した場合は、下部にもコピーしてください) -->   
        <!-- ここから -->
        <div class="cx_autocomplete_pagination" v-if="(pageDescription || search) && isTopPlacement == false" :class="{top: isTopPlacement==false}">
              <span class="left" :class="{ disabled: currentPage == 1, loading : isLoading }" @click="onClicked('left')"  id="left"><i class="material-icons small valign">arrow_left</i>戻る</span>                            
               <div>
              <span>{{pageDescription}}</span>
              <span v-if="search" class="filter" @click="onFilterClear()">フィルタ解除</span>
              </div>              
              <span class="right" :class="{ disabled: currentPage == totalPage , loading : isLoading}" @click="onClicked('right')"  id="right">次へ<i class="material-icons small valign">arrow_right</i></span>              
        </div>
        <!-- ここまで -->        
        <!-- シングルコラムもしくは検索結果がない場合 -->
        <b-list-group v-if="widths==null || items.length == 0">
          <b-list-group-item v-if="items.length == 0" class="inactive">マスタが見つかりません。 <span v-if="path" class="cx_link_item" @mousedown="showMaster">登録はこちら</span></b-list-group-item>
          <b-list-group-item :ref="'item' + index" v-for="(item, index) in items" :key="index" :class="{ active: index == selectedIndex }" @mousedown="onItemClick(index,$event)">
            {{ $scopedSlots.default ? '':item.text }}<slot :item="item.value"></slot>
            </b-list-group-item>
        </b-list-group>
        <!-- マルチコラム(検索結果がある場合) -->
        <div class="table" v-if="widths && items.length != 0" >
            <div class="cx_row  list-group-header">
              <div class="cx_col" v-for="(width, index) in widths" :key="index" :data-item-id="index" :style="{width:width +'px'}">
                {{captions[index]}}
              </div>
            </div>          
            <div class="cx_row list-group-item" v-for="(item, row) in items" :key="row" :data-item-id="row" @mousedown="onItemClick(row,$event)" :class="{ active: row == selectedIndex }">
              <div class="cx_col" v-for="(width, index) in widths" :key="index" :data-item-id="index" :style="{width:width +'px'}" >
                <slot :name="'col' + index" :item="item.value"></slot>
              </div>
            </div>
        </div>
        <!-- ヘッダを下部に表示する場合(コピーしてください) -->
        <!-- ここから -->
        <div class="cx_autocomplete_pagination" v-if="(pageDescription || search) && isTopPlacement">
              <span class="left" :class="{ disabled: currentPage == 1, loading : isLoading }" @click="onClicked('left')"  id="left"><i class="material-icons small valign">arrow_left</i>戻る</span>              
               <div>
              <span>{{pageDescription}}</span>
              <span v-if="search" class="filter" @click="onFilterClear()">フィルタ解除</span>
              </div>
              <span class="right" :class="{ disabled: currentPage == totalPage , loading : isLoading}" @click="onClicked('right')"  id="right">次へ<i class="material-icons small valign">arrow_right</i></span>              
        </div>        
        <!-- ここまで -->
      </div>

      <div class="cx_autocomplete_wrapper" slot="reference" :class="{ 'is-invalid': validator.isInvalid }" ref="input" :tabindex="0">
        <b-form-input class="cx_autocomplete" ref="target" :class="{ 'is-invalid': validator.isInvalid,apps :showFunc,buttons: $scopedSlots.buttons }" autocomplete="off" v-model="search" type="text" placeholder="検索ワードを入力" size="sm">
          <span>1</span>
        </b-form-input>
        <div class="func_buttons">
          <div class="func_button">
            <div class="inline_button delete" @mousedown="onDelete" ref="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                <path d="M0 0h24v24H0z" fill="none" />
              </svg>
            </div>
          </div>
          <div class="cx_autocomplete_button" :class="{loading: isLoading}" ref="button" @mousedown="onButtonClicked"></div>
          <slot name="buttons" :value="value"></slot>
          <b-button @click="onFuncClick"  ref="extra_button" v-if="showFunc" :disabled="$api.perms.hasMenuPermission(funcPerm)==false">
            <i class="material-symbols-outlined small valign" style="pointer-events:none;">apps</i>
          </b-button>           

        </div>
      </div>
    </template>
  </Control>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';
import Popper from 'popper.js';

@Component
export default class AutoComplete extends Vue implements Components.IControl {
  @Prop({ default: '' }) public title?: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem; //コードもしくはオブジェクト
  @Prop({ default: '' }) public placeholder?: string;
  @Prop({ default: null }) public list?: string;
  @Prop({ default: null }) public query?: string;
  @Prop({ default: null }) public provider: () => Promise<Common.BindItem[]>;
  @Prop({ default: null }) public queryProvider: (search:string, perPage: number, currentPage: number) => Common.LoadQuery;
  @Prop({ default: false }) public required?: boolean;
  @Prop({default:false}) public keyfield: boolean;    
  @Prop({ default: true }) public isDirectEditEnabled: boolean;
  @Prop({ default: null }) public nullValue: any | Common.IMasterItem;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: 8 }) public displayCount: number;
  @Prop() public tooltip: string;
  @Prop({default:false}) public isLink: boolean;
  @Prop({ default: null }) public path: string;

  @Prop({ default: null }) public captions: Array<string>;
  @Prop({ default: null }) public widths: Array<number>;
  @Prop({ default: false }) public showFunc:boolean;
  @Prop({ default: null }) public funcPerm: string;

  public popperJS: Popper = null;
  public showPopper: boolean = false;

  public ajax: boolean;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator;

  public isLoading: boolean = false;
  public search: string = ''; //インプットテキスト
  public selectedIndex: number = 0; //ポップアップのIndex
  public items: any = new Array(0); //ポップアップ用の動的リスト

  public isResetting: boolean = false;
  public displayName: string = '';

  //検索結果のページング処理用の属性(クエリモードのみ)
  public totalPage:number = 1;
  public currentPage:number = 1;
  public pageDescription = '';
  // public perPage:number = 5; displayCountを使用する


  public showFuncTarget: HTMLElement = null;

  public isTopPlacement: boolean = false;  
  public isEnableCategoryAtc: boolean;
  //formatter(ajax) + code =>対応 =>formatter側の動作をajaxに変更する
  //formatter + object =>対応
  //ajax + object =>対応
  //ajax + code =>非対応(一覧表示できないので意味がない)
  public getDisplayName(): Promise<string> {
    if (this.value == this.nullValue) {
      return Promise.resolve('');
    } else if (this.query != null || this.queryProvider != null) {
      //クエリモードの場合
      return Promise.resolve((this.value as Common.IMasterItem).name);
    } else if (this.provider != null) {
      //プロバイダモードの場合～現状ではユースケースが不明なのでローカルでの検索処理とする
      let selected: Common.BindItem = null;
      return this.provider().then(items => {
        items.forEach(item => {
          if (item.value == this.value) selected = item;
        });
        return Promise.resolve(selected == null ? '' : selected.text);});
    } else {
      //リストモードの場合
      return this.$api.formatter.formatByListAjax(this.value, this.list);
    }
  }

  //マスタ画面を別タブで開く
  public showMaster(){
      let routeData = this.$router.resolve(this.path);
      window.open(routeData.href, '_blank');          
  }

  // ******* 作業　***********
  // マスタ項目数が増えた場合にformatがうまく動作しないように思う...一行毎に検索を掛けるのは現実的ではない。
  // オートコンプリートは名前以外の項目も表示・検索が必要になるかもしれないので、その場合は検索ワードで検索するのも合理的かもしれない。
  // つまりajaxはそれほど重要ではないかもしれない。

  // ******* 初期化　*********

  created() {
    this.validator = new Components.ControlValidator(this, 'tooltip', this.internalValidate);
    if (this.editor != null) this.editor.addControl(this);
    if (this.list) this.$api.formatter.ensureListLoaded(this.list).then(()=>this.$forceUpdate());     
    document.body.addEventListener('mousedown',this.onMouseDownOtherElement);
    this.isEnableCategoryAtc = this.$api.useOperationFunction || this.$api.tenantVersion < Common.TenantVersions.Version_241220 || this.path != '/master/Category';
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
    document.body.removeEventListener('mousedown',this.onMouseDownOtherElement);        
  }

  updated() {
    if (this.$refs.target != null) {
      //mount時点でisEdit:=falseのためバインドできない場合がある。複数ハンドラが関連付けられるリスクあるが。。
      ((this.$refs.target as Vue).$el as HTMLElement).onkeydown = this.keyDown;
      ((this.$refs.target as Vue).$el as HTMLElement).onmousedown = this.onStart;
      // ((this.$refs.target as Vue).$el as HTMLElement).onblur = this.onExit;
      //Inputエレメント単体のフォーカスでは網羅できないのでコントロール全体のfocusoutで制御する
      //focusを受け取れない場所があるとe.relatedTarget=nullになり、その後制御できなくなるので留意が必要
      this.$el.addEventListener('focusout',this.onExit);
      // ((this.$refs.target as Vue).$el as HTMLElement).onwheel = this.onWheel;      
    }
  }

  mounted() {
    //((this.$refs.button as Vue).$el as HTMLElement).addEventListener('click', this.onClickOtherElement, {capture: true,});

    this.reset();
    this.hide(); //バインドしないと初期表示される
  }

  @Watch('provider')
  public onProviderChange() {
    if (this.provider != null) {
      this.getItems('',1).then(results => (this.items = results));
    }
  }

  public get internalValue(): any | Common.IMasterItem {
    return this.value;
  }

  public set internalValue(value: any | Common.IMasterItem) {
    // 親コンポーネント側で更新
    if (this.internalValue != value) {
      this.$emit('update:value', value);
      this.$emit('changed');
      this.$nextTick(() => this.validator.update());
    } else {
      this.reset();
    }
  }

  // ******* 遷移イベント *******
  public onLinkClick(){
    this.$emit('linkClicked');
  }
  public onFuncClick(event:any){
    this.$emit('funcClicked',event);
  }
  // ******* 監視イベント *******

  @Watch('value')
  public onValueChange(value: string | Common.IMasterItem) {
    //データソース更新後にリセットする
    this.reset();
  }

  @Watch('search')
  public onChange(newValue: string, oldValue: string) {
    if (this.isResetting) {
      this.isResetting = false;
      return;
    } else if (newValue != oldValue) {
       this.initiatePopup();
      // if (newValue.length > 0) {
      //   //検索文字列が1文字以上ある場合はフィルタする
      //   this.getItems(newValue,1).then(results => {
      //     this.items = results;
      //     this.$forceUpdate();
      //     this.popup();
      //   });
      // } else {
      //   //検索文字列がない場合はリセットする
      //   this.internalValue = this.nullValue;
      //   this.hide();
      // }
    }
  }
  public onMouseDownOtherElement(e : MouseEvent){
    var parent = this.$refs.parent as Vue;
    if (parent.$el.contains(e.target as HTMLElement) == false) this.hide();
  }

  public onClicked(button:string){
    if (button == 'left' && this.currentPage > 1){
      this.getItems(this.search, this.currentPage -1).then(results => {
          this.items = results;
          this.$forceUpdate();
          this.popperJS.update();
          // this.popup();
      });
    } else if (button == 'right' && this.currentPage < this.totalPage){
      this.getItems(this.search, this.currentPage +1).then(results => {
          this.items = results;
          this.$forceUpdate();
          this.popperJS.update();          
          // this.popup();
      });;      
    }
  }
  public onFilterClear(){
    this.search = '';
    this.$forceUpdate();    
  }
  /**検索結果の合計ページ数をセットします */
  private setTotalPage(recordCount:number){
      //レコードがない場合は1ページをセットする
      if (recordCount == 0){
        this.totalPage = 1;
        this.pageDescription = '';
      } else {
      this.totalPage = Math.ceil(recordCount / this.displayCount);
      var startCount = this.displayCount * (this.currentPage -1) +1;
      var endCount = Math.min(this.displayCount * this.currentPage, recordCount);
      this.pageDescription = String.format('{0} - {1} 件 (全 {2} 件)',startCount,endCount,recordCount);
      }

  }
  startWaitCursor(){
    this.isLoading = true;
  }
  closeWaitCursor(){
    this.isLoading = false;
  }
  public async getItems(filter: string, page:number):Promise<Common.BindItem[]> {
    //カレントページを更新する。
    this.startWaitCursor();
    this.currentPage = page;
    //戻り値でtotalPageを更新します。
    if (this.query != null || this.queryProvider != null) {
      //クエリモード
      var query : Common.LoadQuery;
      if (this.query != null) {
        query = this.$api.createInstance(this.query); //this.$api.binders[this.query].createInstance() as Common.LoadQuery;
        query.search = filter;
        query.perPage = this.displayCount;
        query.currentPage = page;
      } else if (this.queryProvider != null){
        query = this.queryProvider(filter,this.displayCount,page);
      }

      return this.$api.execute(query).then(result => {
        const results: Common.BindItem[] = new Array();
        for (const option of (result as Common.LoadResult).result) {
          results.push({ text: (option as Common.IMasterItem).name, value: option });
          if (results.length >= this.displayCount) break;
        }
        //ページ処理対応
        this.setTotalPage((result as Common.LoadResult).records);
        this.closeWaitCursor();
        return Promise.resolve(results);
      });
    } else if (this.provider != null) {
      //プロバイダモード～現状ではユースケースが不明なのでローカルでのページ処理とする
      const results: Common.BindItem[] = new Array();
      return this.provider().then(items => {
        
        for (const option of items) {
          if (option.text != '' && option.text.toLowerCase().includes(filter.toLowerCase())) {
            results.push({ text: option.text, value: option.value });
          }                
        }    
        this.setTotalPage(results.length);//ページ処理非対応
        this.closeWaitCursor();     
        return Promise.resolve(results.slice(this.displayCount * (page -1), this.displayCount * page));
      });
    } else {
      //リストモード
      return this.$api.formatter.getOptionsAjax(this.list, filter,this.displayCount,page).then(result =>{
        const results: Common.BindItem[] = new Array();
        for (const option of (result as Common.LoadResult).result) {
          results.push(option);
        }
        //ページ処理対応
        this.setTotalPage((result as Common.LoadResult).records);
        this.closeWaitCursor();             
        return Promise.resolve(results);
      });
    }
  }

  reset() {
    //データソース値で入力欄をリセットし、検索候補を取得します。
    this.getDisplayName().then(text => {
      this.displayName = text;
      if (this.search != this.displayName) {
        this.isResetting = true;
        this.search = this.displayName;
      }
      //on 2020.02.19 ポップアップ時に取得する形に変更
      // this.getItems(text,1).then(results => (this.items = results));
    });
  }

  // ******** UIイベント処理 *********

  public keyDown(e: KeyboardEvent) {
    if (e.keyCode == 40 && this.showPopper == false) {
      e.stopPropagation();  // ポップアップを開く場合は親要素のイベントを動作しないようにする
      // this.popup();
      this.initiatePopup();
      return;
    }

    if (e.keyCode == 38 && this.selectedIndex == 0 && this.showPopper == true) {
      this.hide();
      return;
    }

    //ESCキー
    if (e.keyCode == 27 && this.showPopper == true) {
      this.hide();
      return;
    }
    //Leftキー
    if (e.keyCode == 37 && this.showPopper == true) {
      this.onClicked('left');
      return;
    }
    //Rightキー
    if (e.keyCode == 39 && this.showPopper == true) {
      this.onClicked('right');
      return;
    }    
    //Upキー
    if (e.keyCode == 38 && this.selectedIndex > 0) {
      e.stopPropagation();  // ポップアップで上下する場合は親要素のイベントを動作しないようにする
      this.selectedIndex--;
      const itemTop = ((this.$refs['item' + this.selectedIndex] as Array<any>)[0] as HTMLElement).getBoundingClientRect().top;
      const rectTop = (this.$refs.rect as HTMLElement).getBoundingClientRect().top;
      if (itemTop < rectTop) {
        (this.$refs.rect as HTMLElement).scrollBy(0, itemTop - rectTop);
      }
    }
    //Downキー
    if (e.keyCode == 40 && this.selectedIndex < this.items.length - 1) {
      e.stopPropagation();  // ポップアップで上下する場合は親要素のイベントを動作しないようにする
      this.selectedIndex++;
      const itemBottom = ((this.$refs['item' + this.selectedIndex] as Array<any>)[0] as HTMLElement).getBoundingClientRect().bottom;
      const rectBottom = (this.$refs.rect as HTMLElement).getBoundingClientRect().bottom;
      if (itemBottom > rectBottom) {
        (this.$refs.rect as HTMLElement).scrollBy(0, itemBottom - rectBottom);
      }
    }
    
    //Enterキー
    if (e.keyCode == 13) {
      if (this.selectedIndex >= 0 && this.selectedIndex < this.items.length) {
        this.internalValue = (this.items[this.selectedIndex] as any).value;
      } else {
        // this.internalValue ='';
      }
      this.hide();
    }
  }
  public onWheel(event: any) {
    if (event.deltaY >0 && this.selectedIndex < this.items.length - 1) this.selectedIndex++;
    else if (event.deltaY <0 && this.selectedIndex > 0 ) this.selectedIndex--;
  }

  public onItemClick(index: number, e:MouseEvent) {
    //ポップアップが閉じる際にフォーカスを失うので先に戻す
    ((this.$refs.target as Vue).$el as HTMLElement).focus();
    //リストアイテムのキーダウンイベント(blurイベントに先行する)
    this.internalValue = (this.items[index] as any).value;
    this.hide();
    e.preventDefault();
  }

  public onExit(e:any) {
    if (e.relatedTarget && this.$refs.rect && (this.$refs.rect as HTMLElement).contains(e.relatedTarget) ){    
    // if (e.relatedTarget && (e.relatedTarget.id =='left' || e.relatedTarget.id =='right') ){
      //フォーカスをコントロールに戻す
      e.target.focus();
    } else if (e.relatedTarget && e.relatedTarget.className == 'modal-content' && e.sourceCapabilities == null){
      //モーダル上で表示されている場合に矢印ボタンを押した際に不要なフォーカスアウトとフォーカスインが発生する
        this.$nextTick(()=>e.target.focus());
    } else {
      this.reset();
      this.hide();
    }

  }

  public onStart() {
    this.selectedIndex = 0;
  }

  public onButtonClicked() {
    this.selectedIndex = 0;
    // if (this.items == undefined) this.getItems('').then(results => this.items = results);
    ((this.$refs.target as Vue).$el as HTMLElement).focus();
    if (this.showPopper) {
      this.hide();
    } else {
      // this.popup();
      this.initiatePopup();
    }
    event.preventDefault();

    // this.$nextTick(()=>{

    // });
  }

  public onDelete() {
    //入力リセットボタンを押すと入力欄をクリアしてポップアップは閉じる
    this.internalValue = this.nullValue;
    ((this.$refs.target as Vue).$el as HTMLElement).focus();    
    event.preventDefault(); //フォーカスが移動するのをふせぐ
    this.hide();
  }

  initiatePopup(){
    this.getItems(this.search,1).then(results => {
          this.items = results;
          this.popup();
    });
  }
  // ******** ヘルパ関数 *********

  popup() {
    // this.$nextTick(() => {
    // if (this.$refs.popper != null) {

    //   if ((this.$refs.popper as any).showPopper) {
    //     (this.$refs.popper as any).updatePopper();
    //   } else {
    //     (this.$refs.popper as any).showPopper = true;
    //   }
    //   this.selectedIndex = 0;

    // }
    if (this.popperJS) {
      this.popperJS.scheduleUpdate();
    } else {
      this.showPopper = true;
      this.$nextTick(() => {
        //直接入力時のポップアップ位置がWindowsのみでずれたためpositionFixedに変更。
        const options = { placement: 'auto', eventsEnabled: false, modifiers: { setWidth: { enabled: true, order: 840, fn: this.setWidth } }, computeStyle: { gpuAcceleration: false }, positionFixed: true };
        this.popperJS = new Popper(this.$refs.input as HTMLElement, this.$refs.rect as HTMLElement, options as any);
        this.popperJS.enableEventListeners();
      });
    }
    this.selectedIndex = 0;
    // });
  }

  hide() {
    this.showPopper = false;
    this.$nextTick(() => {
      if (this.popperJS) {
        this.popperJS.disableEventListeners();
        this.popperJS.destroy();
        this.popperJS = null;
      }

      this.selectedIndex = -1;
      // if (this.$refs.popper != null) {
      //   (this.$refs.popper as any).showPopper = false;
      //   this.selectedIndex = -1;
      // }
    });
  }

  setWidth(data: any) {

    var width = Math.round(data.offsets.reference.width);
    //ヘッダの最小幅をセット
    if (width<300) width = 300;

    if (this.widths) width= this.widths.reduce((prev,current)=>prev+current);
    width +=17; //マージンとボーダー

    if (width > window.innerWidth) width=window.innerWidth;
    var paddingX = 0;
    if (data.offsets.reference.right - width < 0) paddingX = width - data.offsets.reference.right;

    data.offsets.popper.left = data.offsets.reference.right - width + window.scrollX + paddingX;
    data.offsets.popper.right = data.offsets.reference.right + window.scrollX + paddingX;
    data.offsets.popper.width = data.styles.width = width;
    //8行表示の高さが233なので少し余裕を見て240で判定(実際の高さは表示行数によって可変になり上下移動を回避するため固定値をセット)
    if(window.innerHeight - data.offsets.reference.bottom < 240) {
      data.offsets.popper.top = data.offsets.reference.top - data.offsets.popper.height - 2 + window.scrollY;   
      this.isTopPlacement = true;
    }
    else {
      data.offsets.popper.top = data.offsets.reference.bottom  + window.scrollY;
      this.isTopPlacement = false;
    }

    // if(this.widths){
    //   //複数カラムの場合は固定幅で表示する
    //   var width = this.widths.reduce((prev,current)=>prev+current);
    //   data.offsets.popper.left = data.offsets.reference.right - width + 2;
    //   data.offsets.popper.right = data.offsets.reference.right;
    //   data.offsets.popper.width = data.styles.width = width;
    //   data.offsets.popper.top = data.offsets.reference.bottom;
    // } else {
    //   data.offsets.popper.left = data.offsets.reference.left +1;
    //   data.offsets.popper.right = data.offsets.reference.right;
    //   data.offsets.popper.width = data.styles.width = Math.round(data.offsets.reference.width);
    //   data.offsets.popper.top = data.offsets.reference.bottom;
    // }

    return data;
  }
  // ******** バリデーション　***********

  public internalValidate(): string {
    const value = this.internalValue;
    if (this.required && value == null) {
      return '必須項目です';
    } else if (this.required && typeof value == 'string' && (value as string).length == 0) {
      return '必須項目です';
    }

    return '';
  }
}
</script>
<style lang="scss">
.popperList {
  z-index: 999;
  width: 100%;
  /* margin-right: 27px;
  margin-left: 28px; */
  max-height: 240px;
  /* width: 381.5px; */
  overflow-y: auto;
  border: solid #a2c9f3 1px;

  border-radius: 3px; 
  margin-top: 1px;
  // margin-left:-1px;
  box-shadow: 0px 0px 1px 1px rgb(221, 221, 221);


  .table {
    display:flex;
    flex-direction: column;
    overflow: hidden;
      // border: solid #000 1px;
      margin: 0;
    .cx_row {
      display: flex;
      flex:1;
      overflow: hidden;
      .cx_col {
        overflow: hidden;
        white-space: nowrap;
        padding-left:2px;
        padding-right:2px;
      }      
    }    
  }
}
.popperList .list-group-header {
  border: 0;
  background-color:  #f3f3f3;
  font-size: 11px;
  line-height: 1.2;
  /* height: calc(1.5em + 0.5rem + 2px); */
  padding: 3px 5px;
  border-radius: 0px;
  border-bottom: solid 1px rgb(219, 219, 219);
}

.popperList .list-group-item {
  border: 0;

  font-size: 13px;
  line-height: 1.4;
  /* height: calc(1.5em + 0.5rem + 2px); */
  padding: 3px 5px;
  border-radius: 0px;
  // border-color: #007bff;

  &.inactive{
    color: #a09f9f;
  }
}

.popperList .list-group-item:hover:not(.inactive) {
  background-color: rgb(233, 232, 232);
  cursor: pointer;
  &.active {
    background-color: #007bff;
  }
}
.cx_autocomplete {
  &:not(.apps):not(.buttons){
  padding-right: 32px !important; //文字の重なり防止
  }
  &.apps{
    padding-right: 56px !important; //文字の重なり防止    
  }
  &.buttons{
    padding-right: 56px !important; //文字の重なり防止    
  }  
  &.apps.buttons{
    padding-right: 80px !important; //文字の重なり防止    
  }    
}
.cx_autocomplete::after {
  content: '';
  background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M7%2010l5%205%205-5z%22%2F%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-position: right calc(0.15em + 0.1rem) center;
}
.cx_autocomplete_pagination{
  background-color: #f3f3f3;
  display:flex;
  justify-content: space-between;
  align-items: center;
  &.top{
    //上に配置
    border-bottom: solid 1px rgb(219, 219, 219);
  }
  &:not(.top){
    //下に配置
    border-top: solid 1px rgb(219, 219, 219);  
  }
  height: 25px;
  & .loading {
    cursor: wait;        
  }  

  .left{
    margin: 2px 1px 2px 6px;
    // color:#007bff;          
    color:white;    
    background-color: #6c757d;
    border-color: #6c757d;
      height: 16px;
      border-radius: 2px;    
      padding-right: 7px;
    &:hover:not(.disabled):not(.loading){
      // background-color: #e4e4e4;
      cursor:pointer;
      // text-decoration:underline;
      background-color: #5a6268;
      border-color: #545b62;                  
    }

    &.disabled{
      // color: #888;
      // color:transparent;      
      opacity: 0.25;   
      cursor:default;      
    }

    i{
      margin-top:-2px;
    }
  }
  span{
    font-size: 11px !important;
    width:auto;
  }
  .filter{
    margin-left:5px;
    color: #f8361c;
    &:hover{
      // background-color: #e4e4e4;
      cursor:pointer;
      text-decoration:underline;
    }    
  }

  .right{
      margin: 2px 6px 2px 1px;     
      // color:#007bff;      
      color:white;
    // margin-left:auto;
      background-color: #6c757d;
      border-color: #6c757d;    
      height: 16px;
      border-radius: 2px;
      padding-left: 7px;      
    &:hover:not(.disabled):not(.loading){
      // background-color: #e4e4e4;
      cursor:pointer;
      // text-decoration:underline;        
      background-color: #5a6268;
      border-color: #545b62;                 
    }
    &.disabled{
      // color: #888;
      // color:transparent;
      opacity: 0.25; 
      cursor:default;
    }
    i{
      margin-top:-2px;
    }    
  }
}
.cx_autocomplete_wrapper {
  position: relative;
}
.func_buttons {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;  
  display:flex;

    button{
           padding: 1px 2px;
            font-size: 14px;
            line-height: 16px;
        //             border-top-left-radius: 0rem;
        // border-bottom-left-radius: 0rem;
            border-radius: 0rem;
        &:last-child {
          border-top-right-radius: 0.25rem;
          border-bottom-right-radius: 0.25rem;          
        }
        &:not(:last-child) {

          border-right: 1px solid #545b62;
          
        }
    }  
}
.cx_autocomplete_button {

  // position: absolute;
  // right: 0;
  // top: 0;
  // bottom: 0;
  width: 18px;
  height: 22px;
  background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M7%2010l5%205%205-5z%22%2F%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  // background-position: right calc(0.19em + 0.1rem) center;
  background-position: left -6px top -2px;

  &:not(.loading){
    cursor: pointer;
  }
  &.loading {
    cursor: wait;
  }  
}

.is-invalid .cx_autocomplete_button {
  // background-position: right calc(1.39em + 0.1rem) center;
  // width: 50px;
}

.cx_autocomplete_button:hover {
  background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M7%2010l5%205%205-5z%22%20fill%3D%22%233194ff%22%2F%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E');
}

.func_button {
  // position: absolute;
  // right: 0;
  // top: 0;
  // bottom: 0;
  // width: 20px;
  display: flex;
  justify-content: flex-start;

  .inline_button {
    cursor: pointer;
    // width: 22px;
    height: 20px;
    // padding-left: 2px;
    margin-top: 0px;
    &.delete {
      // width: 16px;

      svg {
        fill: lightgray;
        &:hover {
          fill: rgb(238, 83, 83);
        }
      }
    }
    svg {
      height: 14px;
      width: 14px;
      fill: #444;
      &:hover {
        fill: #007bff;
      }
    }
  }
}

.cx_autolink{
  // font-weight: bolder;
  color: #007bff !important; 
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  
}
</style>
